var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hierarchiesPivotTableFilters"},[_vm._t("filters",[_c('div',[_vm._v("Default slot")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }